export default __webpack_public_path__ + "images/943c543afd9f1cd9953db15f3a90832b.svg";